import { Owned } from 'app/model/base/named';
import { DataFlow } from 'app/model/dataflow/dataflow';
import { DataFlowExpressionUtils } from '../../expression.util';
import { ParameterPlainObject } from 'worker/app-workers/shared/plainObjects/parameter.plainObject';
import { DataFlowParameter } from 'app/model/dataflow/dataflow-parameter';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { SchemaConvertor } from './schema.convertor';

export class ParameterConvertor {
    constructor(protected functionObject: ParameterPlainObject, protected dataflow: DataFlow) {}

    public async convert(): Promise<DataFlowParameter> {
        const parameter = Owned.create<DataFlowParameter>(DataFlowParameter.MODEL, this.dataflow);
        const defaultValue = this.functionObject.defaultValue;
        parameter.name = this.functionObject.name;
        parameter._dataflowType = SchemaConvertor.convertDataType(this.functionObject.dataType);

        parameter.defaultValueExpression = defaultValue
            ? DataFlowExpressionUtils.unwrapExpressionConfigValue(defaultValue, this.dataflow, parameter._type)
            : Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, parameter);

        return parameter;
    }
}
